
import React, { useState, useEffect ,useContext} from "react";
import { useNavigate, Link } from "react-router-dom";
import * as Config from "../../constants/Config";
import moment from "moment";
import tmdbApi from "../../api/tmdbApi";
import axios from "axios";
import { contentContext } from "../../context/contentContext";
let { lambda, country, appname } = window.app;

const Header = ({fn}) => {

    const navigate = useNavigate();
const [image, setImg] = useState(process.env.REACT_APP_IMAGE_CLOUD_FRONT);
    const [data, setData]= useState("");
    const [userName, setUserName]= useState([]);


    const { userData , setUserData,businessData,setBusinessData,  clientInfo, setClientInfo,setShowPopup,setSelectedOptions,setMultiSelectFields,uploadLogo,setActiveFieldsObj,setActiveMenuObj,
        setSelectedOptionsClientName,setSearchPayload,setInitialCategoriesData1 ,toggleMenu,setToggleMenu, GetTimeActivity} = useContext(contentContext)

    const handleProfile = (e) => {
        GetTimeActivity();
        navigate("/profile");
     }
//  const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
     const handleLogout = (e) => {
        GetTimeActivity();
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("ClientName");
        localStorage.removeItem("ClientType");
        localStorage.removeItem("clientid");
       
        signoutsession();
       
        // console.log('loginType',loginType);
     
        
             navigate("/");
            //  localStorage.removeItem("login_type");
       
        setUserData([])
        setActiveMenuObj({
            "Client Management": false,
            "Reports": false
        })
        setInitialCategoriesData1([])
        setSelectedOptions([])
        setMultiSelectFields({dubbinglanguages:[],typeofrights:[],countryorigin:[], languages :[], typeofrights :[], genre :[], videoquality :[], certificate :[], subtitleslanguages :[], territoriesavailable :[], sport :[], musicgenre :[]})
        setActiveFieldsObj({CookingshowActive:false,seriesActive:false,SportsActive:false,LiveEventActive:false,MusicActive:false})
        setSelectedOptionsClientName([])
        setSearchPayload({})
        setShowPopup(false)
        
     }
    
    
   
     useEffect(() => {
 
         if (window.site === undefined) {
             setTimeout(() => {
                 if (window.site && window.site.common && window.site.common.imageCloudfront) {
                     setImg(window.site.common.imageCloudfront)
                 }
             }, 1000);
         }
         if (window.site && window.site.common && window.site.common.imageCloudfront) {
             setImg(window.site.common.imageCloudfront)
         }
     
     
     }, [window.site]);

      useEffect(() => {
        // userName = localStorage.getItem("ClientName")?.split(" ");
      
            setUserName(userData?.name?.split(" "));  
      
         // console.log("userDtata----------------------->",userData)
       
      }, [ userData]);
      const signoutsession = async () => {
        GetTimeActivity();
        try {
       //    const response = await tmdbApi.SignOutUser({ emailid: userData.email });

         
          // console.log('loginType',loginType);
          let response;
          
           response = await tmdbApi.SignOutUser({ emailid: userData.emailid },'kkkkkkk');
          
           
    
        } catch {
          console.log("error");
        }
      }
    

    
    // console.log("clientInfoooooooooooooooooooooooo",clientInfo)
const handleEdit=()=>{
    // setBusinessData(clientInfo)
    navigate("/businessprofile")
}

      const handleRedirect = () => {
        GetTimeActivity();
        let userArr = userData.permissions

        // console.log("userArr",userData)

                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // console.log('objjjjjjjj--->',obj)

                let k = userData

                let permissionList = userData && userData.permissions
                let filterdList = permissionList.filter((item) => item.display===true)
                let id = filterdList && filterdList[0] && filterdList[0].menu.split(" ").join("").toLowerCase()

                navigate("/" + id);
      }

    //   let userName=[]
    //   userName = localStorage.getItem("ClientName")?.split(" ");
const handleUpgrade=()=>{
   navigate("/upgradeplan") 
}
const handleMenuToggle = () => {
    setToggleMenu(!toggleMenu)
}

    return (
        <>

            <header id="page-topbar">
                <div className="navbar-header admin_header" >
                    <div className="d-flex">
                        <div className="navbar-brand-box"
                        >
                            <a 
                           //  onClick={handleRedirect} 
                            className="logo">
                                <span className="logo-sm">
                                <img src="./assets/img/brand/logo-sm.png"/>
                                </span>
                                <span className="logo-lg"> 
                               
                                
                                <img 
 src={ `${image}${appname}/images/web/logo-white.svg`}
  
 alt="Logo"
/>

                              
                                </span>
                                <span className="Admin-badge">
Admin
</span>

                            </a>
                        </div>

                        <button type="button" className="btn btn-sm px-3 font-size-16 header-item waves-effect"
                            id="vertical-menu-btn" onClick={handleMenuToggle}>
                            <i className="fa fa-fw fa-bars"></i>
                        </button>


                        {/* <form className="app-search d-none d-lg-block">
                            <div className="position-relative">
                                <input type="text" className="form-control" placeholder="Search..." />
                                <span className="bx bx-search-alt"></span>
                            </div>
                        </form> */}


                    </div>

                    <div className="d-flex profile_section">

                        <div className="dropdown d-lg-none ms-2">
                            <button type="button" className="btn header-item noti-icon waves-effect"
                                id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <i className="mdi mdi-magnify"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                                aria-labelledby="page-header-search-dropdown">

                                <form className="p-3">
                                    <div className="form-group m-0">
                                        <div className="input-group">
                                            <input type="text" className="form-control" placeholder="Search ..."
                                                aria-label="Recipient's username" />
                                            <div className="input-group-append">
                                                <button className="fill-btn-style" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

{/* <div className="dropdown d-inline-block ms-3 d-flex align-items-center header-logo-section">
        <div className="header-logo-container me-3">
        <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/67c004ca91fc60a506fd97b9/fairfield_marriot_image_1740637386042.jpg" alt="Dario Bar Logo" className="rounded" width="40" height="40"/>
        <span className="material-symbols-outlined edit-icon">edit</span>
        </div>
        <div>
        <p className="menu-path mb-0">Welcome</p>
        <h4 class="card-title mb-0">Dario Bar and Lounge</h4>
        </div>
</div> */}
 {/* <div className="dropdown d-inline-block ms-3 d-flex align-items-center header-logo-section">
<div className="header-logo-container me-3">
  <div id="logo-upload-container" className="no-logo-block">
    {clientInfo?.logo===""?<span class="material-symbols-outlined">storefront</span>:   <img src={ `${image}${clientInfo?.logo}`} alt="Dario Bar Logo" className="rounded" width="40" height="40"/>}
    <span class="material-symbols-outlined">storefront</span>
 
  </div>
</div>

        <div className="edit-wrapper me-2">
        <p className="menu-path mb-0">Welcome</p>
        <h4 class="card-title mb-0">{clientInfo?.businessname}</h4>
        </div>
        <input 
      id="logo-upload" 
      accept="image/jpeg, image/png, image/heic, image/jpg" 
      className="d-none logo-input" 
      type="file"
    />
   
   

</div> */}


                        <div className="dropdown d-flex align-items-center">
                        <div className="d-flex me-3">
                        <div className="d-flex align-items-center">
                        {/* {!localStorage.getItem('login_type')&&
                        <>
                        <div className="premium me-2">
                        <div onClick={handleUpgrade}> UPGRADE <span className="material-symbols-outlined f-5">
crown
</span></div>
                        </div>
                        <button type="button" className="btn header-item noti-icon waves-effect"
                        id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <i className="bx bx-bell bx-tada"></i>
                        <span className="badge bg-danger rounded-pill">3</span>
                    </button>
                        </>
                        
                        } */}

                        {/* <label className="form-label">Login: {localStorage.getItem("loginTime")}</label>    */}
                        
                        </div>
                            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                                aria-labelledby="page-header-notifications-dropdown">
                                <div className="p-3">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h6 className="m-0" key="t-notifications"> Notifications </h6>
                                        </div>
                                        <div className="col-auto">
                                            <a href="#!" className="small" key="t-view-all"> View All</a>
                                        </div>
                                    </div>
                                </div>
                                <div data-simplebar style={{ maxHeight: "230px" }}>
                                    <a href="" className="text-reset notification-item">
                                        <div className="d-flex">
                                            <div className="avatar-xs me-3">
                                                <span className="avatar-title bg-primary rounded-circle font-size-16">
                                                    <i className="bx bx-cart"></i>
                                                </span>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h6 className="mb-1" key="t-your-order">Your order is placed</h6>
                                                <div className="font-size-12 text-muted">
                                                    <p className="mb-1" key="t-grammer">If several languages coalesce the
                                                        grammar</p>
                                                    <p className="mb-0"><i className="mdi mdi-clock-outline"></i> <span
                                                        key="t-min-ago">3 min ago</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                    <a href="" className="text-reset notification-item">
                                        <div className="d-flex">
                                            <img src={image+Config.img + "avatar-3.jpg"}
                                                className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                            <div className="flex-grow-1">
                                                <h6 className="mb-1">James Lemire</h6>
                                                <div className="font-size-12 text-muted">
                                                    <p className="mb-1" key="t-simplified">It will seem like simplified English.
                                                    </p>
                                                    <p className="mb-0"><i className="mdi mdi-clock-outline"></i> <span
                                                        key="t-hours-ago">1 hours ago</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                    <a href="" className="text-reset notification-item">
                                        <div className="d-flex">
                                            <div className="avatar-xs me-3">
                                                <span className="avatar-title bg-success rounded-circle font-size-16">
                                                    <i className="bx bx-badge-check"></i>
                                                </span>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h6 className="mb-1" key="t-shipped">Your item is shipped</h6>
                                                <div className="font-size-12 text-muted">
                                                    <p className="mb-1" key="t-grammer">If several languages coalesce the
                                                        grammar</p>
                                                    <p className="mb-0"><i className="mdi mdi-clock-outline"></i> <span
                                                        key="t-min-ago">3 min ago</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </a>

                                    <a
                                     href="" 
                                     className="text-reset notification-item">
                                        <div className="d-flex">
                                            <img src={image+Config.img + "avatar-4.jpg"}
                                                className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                            <div className="flex-grow-1">
                                                <h6 className="mb-1">Salena Layfield</h6>
                                                <div className="font-size-12 text-muted">
                                                    <p className="mb-1" key="t-occidental">As a skeptical Cambridge friend of
                                                        mine occidental.</p>
                                                    <p className="mb-0"><i className="mdi mdi-clock-outline"></i> <span
                                                        key="t-hours-ago">1 hours ago</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="p-2 border-top d-grid">
                                    <a className="btn btn-sm btn-link font-size-14 text-center" href="#">
                                        <i className="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">View
                                            More..</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                            <button type="button" className="btn header-item waves-effect" id="page-header-user-dropdown" 
                                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {/* <img className="rounded-circle header-profile-user" src={image + Config.imgmiddle + "avatar-1.jpg"}
                                    alt="Header Avatar" /> */}
                                       
                                            
                                       
                                       <span onClick={GetTimeActivity()} className="user-badge">
                                          {userName?.length > 1 
  ? (
      (userName[0]?.charAt(0) || "").toUpperCase() + 
      (userName[1]?.charAt(0) || "").toUpperCase()
    ) 
  : (
     
        (userData?.name?.slice(0, 2) || "").toUpperCase()
       
    )
}
           </span>
       

                                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">

                                <a className="dropdown-item" onClick={handleProfile} id="profile"><i className="bx bx-user font-size-16 align-middle me-1" id="admin-profile"></i>
                                    <span key="t-profile">Profile</span></a>
                                {/* <a className="dropdown-item" href="#"><i
                                    className="bx bx-wallet font-size-16 align-middle me-1"></i> <span key="t-my-wallet">My
                                        Wallet</span></a>
                                <a className="dropdown-item d-block" href="#"><span
                                    className="badge bg-success float-end">11</span><i
                                        className="bx bx-wrench font-size-16 align-middle me-1"></i> <span
                                            key="t-settings">Settings</span></a>
                                <a className="dropdown-item" href="#"><i
                                    className="bx bx-lock-open font-size-16 align-middle me-1"></i> <span
                                        key="t-lock-screen">Lock screen</span></a> */}
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item text-danger"style={{position:"unset"}} onClick={handleLogout} id="admin-logout"><i style={{position:"unset"}}
                                    className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> <span
                                        key="t-logout">Logout</span></a>
                            </div>
                        </div>

                    </div>
                </div>
            </header>


        </>
    );
};

export default Header;
